<div
  class="alert slide"
  [class.out]="!_message.displayMessage"
  [class.in]="_message.displayMessage"
  [class.alert-success]="_message.messageType == 1"
  [class.alert-info]="_message.messageType == 3"
  [class.alert-danger]="_message.messageType == 2"
  [class.testMargin]="
    inTestEnv && _message.displayMessage && project === 'ADMIN'
  "
>
  <svg class="icon" (click)="_message.displayMessage = false">
    <use
      [attr.href]="
        _message.messageType == 1 ? '#white-tick-green-bg' : '#red-tick-red-bg'
      "
    />
  </svg>
  <p class="margin-bottom-zero">
    <span>{{ _message.message }}</span>
  </p>
</div>
